import { notifications } from '@mantine/notifications';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Toast.module.css';

const TOAST_MS = 5000;
let toastSeq = 0;

export type NotifyWithUndo = (message: string, undo?: () => Promise<void> | void) => void;

/** Every instant save confirms through this: a dark toast at the bottom, with Undo when `undo` is given. */
export function useUndoToast(): NotifyWithUndo {
  const { t } = useTranslation();

  const notifyWithUndo = useCallback<NotifyWithUndo>(
    (message, undo) => {
      toastSeq += 1;
      const id = `undo-toast-${toastSeq}`;
      const onUndo = async () => {
        notifications.hide(id);
        try {
          await undo?.();
        } catch {
          notifications.show({ color: 'red', message: t('ui.undoFailed') });
        }
      };

      notifications.show({
        id,
        position: 'bottom-center',
        autoClose: TOAST_MS,
        withCloseButton: false,
        classNames: { root: classes.root, description: classes.description },
        message: (
          <span className={classes.content}>
            <span>{message}</span>
            {undo && (
              <button type="button" className={classes.undo} onClick={onUndo}>
                {t('ui.undo')}
              </button>
            )}
          </span>
        ),
      });
    },
    [t]
  );

  return notifyWithUndo;
}
